module.exports.blogPostPath = slug => {
  const date = slug.substr(0, 11).replace(/-/g, '/')
  const title = slug.substr(12).replace('/', '')

  return `/blog${date}/${title}`
}
